// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"3a765236","171":"2625e876","223":"d9e30a29","245":"a0468215","295":"1300fc95","356":"a5601674","694":"466af062","949":"8e5b759a"}[chunkId] + ".chunk.js";
};